import { useEffect, useState } from "react";
import "../../assets/styles/components/Footer/Footer.css";
import marstrcards from "../../assets/images/Mastercardimage.svg";
import { RiFacebookCircleFill, RiInstagramLine } from "react-icons/ri";
import { BsYoutube } from "react-icons/bs";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import API from "../../app/api";
import { Link } from "react-router-dom";
import rightarrow from "../../assets/icons/Vector.svg";
import { Toaster, toast } from "react-hot-toast";
import { urlPolicyPage } from "../../utils/url.utils";
import { breakLineOnComma } from "../../utils/text.utils";

const Footer = () => {
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  // Accordion state (for mobile only)
  const [companyOpen, setCompanyOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [contactusOpen, setContactusOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // mobile breakpoint
    };
    handleResize(); // check on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // fetch footer links
  useEffect(() => {
    const fetchFooterLinks = async () => {
      try {
        const res = await API.get("/footer-links/v2");
        if (res.data.success) {
          setFooterData(res.data.data);
        } else {
          setError("Failed to load footer links");
        }
      } catch (err) {
        setError("Something went wrong while fetching footer links.");
      } finally {
        setLoading(false);
      }
    };
    fetchFooterLinks();
  }, []);

  if (loading) return null;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!footerData) return null;

  const { COMPANY, RESOURCES, CONTACT_US, SOCIAL_MEDIA } = footerData;

  const renderIcon = (title) => {
    switch (title.toLowerCase()) {
      case "facebook":
        return <RiFacebookCircleFill size={24} />;
      case "youtube":
        return <BsYoutube size={24} />;
      case "instagram":
        return <RiInstagramLine size={24} />;
      default:
        return null;
    }
  };

  const handleSubscribe = async () => {
    if (!email.trim()) {
      toast.error("Please enter your email address.");
      return;
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    try {
      const res = await API.post("/forms/newsletter-subscribe", { email });
      if (res.data) {
        toast.success("Subscribed successfully!");
        setEmail("");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again later.");
    }
  };

  return (
    <footer className="footer">

      <Toaster reverseOrder={false} containerStyle={{
        zIndex: 999999999,
        marginTop: "60px",
        fontSize: "13px",
      }} position="top-right" />

      {/* NEWSLETTER */}
      <div className="newsletter">
        <h2>Your Home Just Got More Interesting</h2>
        <p className="sub_text" style={{ marginBottom: "0" }}>
          Get updates on new collections, trending products, and curated content you'll love.
        </p>
        <div className="email-signup">
          <input
            type="email"
            placeholder="ENTER EMAIL ADDRESS"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="button_fag" onClick={handleSubscribe}>
            SIGN UP
            <img src={rightarrow} alt="arrow" style={{ width: "13px", marginLeft: "6px" }} />
          </button>
        </div>
        <Link to="/policy/tc-of-sale">
          <p className="sub_text mt-2">
            By signing up you agree with our <u>Terms & Conditions</u>.
          </p>
        </Link>
      </div>

      <div className="footer-links">
        {/* COMPANY */}
        <div className="footer-section">
          <h4
            onClick={() => isMobile && setCompanyOpen(!companyOpen)}
            style={{
              cursor: isMobile ? "pointer" : "default",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            COMPANY {isMobile && (companyOpen ? <AiOutlineMinus /> : <AiOutlinePlus />)}
          </h4>
          {(!isMobile || companyOpen) && (
            <div className="company-links-desktop" style={{ display: "flex", gap: "20px" }}>
              {/* Left Column */}
              <ul>
                {COMPANY?.slice(0, 4).map((item, idx) => (
                  <li key={idx}>
                    <Link to={urlPolicyPage(item.action_url)}>{breakLineOnComma(item.title)}</Link>
                  </li>
                ))}
              </ul>
              {/* Right Column */}
              <ul>
                {COMPANY?.slice(4, 8).map((item, idx) => (
                  <li key={idx}>
                    <Link to={urlPolicyPage(item.action_url)}>{item.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* RESOURCES */}
        <div className="footer-section">
          <h4
            onClick={() => isMobile && setResourcesOpen(!resourcesOpen)}
            style={{
              cursor: isMobile ? "pointer" : "default",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            RESOURCES {isMobile && (resourcesOpen ? <AiOutlineMinus /> : <AiOutlinePlus />)}
          </h4>
          {(!isMobile || resourcesOpen) && (
            <ul>
              {RESOURCES?.map((item, idx) => (
                <li key={idx}>
                  <Link to={`/${item.action_url}`}>{item.title}</Link>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* CONTACT */}
        <div className="contact">
          <h4
            onClick={() => isMobile && setContactusOpen(!contactusOpen)}
            style={{
              cursor: isMobile ? "pointer" : "default",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            CONTACT US {isMobile && (contactusOpen ? <AiOutlineMinus /> : <AiOutlinePlus />)}
          </h4>
          {(!isMobile || contactusOpen) && (
            <>
              <div style={{ display: "flex", gap: "10px" }}>
                <i className="bi bi-geo-alt"></i>
                <p>{CONTACT_US?.address}</p>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <i className="bi bi-telephone"></i>
                <p>
                  <a href={`tel:${CONTACT_US?.phone}`}>{CONTACT_US?.phone}</a>
                </p>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <i className="bi bi-envelope"></i>
                <p>
                  <a href={`mailto:${CONTACT_US?.email}`}><u>{CONTACT_US?.email}</u></a>
                </p>
              </div>
              <div className="social-icons">
                {SOCIAL_MEDIA?.map((item, idx) => (
                  <a key={idx} href={item.link} target="_blank" rel="noopener noreferrer" style={{ color: "#BDBDBD", marginRight: "10px" }}>
                    {renderIcon(item.title)}
                  </a>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} obsessions.co.in | All Rights Reserved</p>
        <img src={marstrcards} alt="Payments" style={{ width: "325px" }} />
      </div>
    </footer>
  );
};

export default Footer;